// extracted by mini-css-extract-plugin
module.exports = {"select":"WorkflowPropertyPicker_select__3yLDD"};